import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import ReportTypeSelect from '../../../MySections/DTechComps/ReportTypeSelect';
import BetweenDates from '../../../MySections/TimeSections/BetweenDates';



const BuisTollBarMobi = (props) => {

    const refreshTheList = (selectedBtn) => {
        props.refreshTheList(selectedBtn)
    }

    return (
        <div className={"buisTollBar buisTollBarMobi"}>
            <div className={"fullRow "}>
                <Button className={`btnMediumMnu onLeft theSBtn`} variant="contained" onClick={() => {
                    refreshTheList(props.selectedBtn);
                }}>
                    רענן
                </Button>
                <div className={"searchWrap onRight"}>
                    <div className="spaceButtomBig ms-form-group my-0 mb-0 has-icon fs-14">
                        <input type="number" className="dtSearchInput ms-form-input" id="dtSearchInput1" name="dtSearchInput"
                            placeholder="מספר הזמנה" value={props.srchText1} onChange={(e) => props.setSrchText1(e.target.value)}
                            onKeyUp={(e) => props.checkIfEnter(e, "orderNUM")}
                        />
                        <Button className="dtSearchIcon flaticon-search text-disabled" onClick={() => props.searchOrder("orderNUM")} />
                    </div>
                </div>
                <div className={"searchWrap onRight"}>
                    <div className="spaceButtomBig ms-form-group my-0 mb-0 has-icon fs-14">
                        <input type="text" className="dtSearchInput ms-form-input" id="dtSearchInput2" name="dtSearchInput"
                            placeholder="טלפון או שם לקוח" value={props.srchText2} onChange={(e) => props.setSrchText2(e.target.value)}
                            onKeyUp={(e) => props.checkIfEnter(e, "byAll")}
                        />
                        <Button className="dtSearchIcon flaticon-search text-disabled" onClick={() => props.searchOrder("byAll")} />
                    </div>
                </div>

            </div>
            <br />
            <Stack direction="row" spacing={2}>
                <div className={"ReportTypeSelect btnMnuTop onRight badge badge-primary"}>

                    <ReportTypeSelect selectedRepo={(selec) => refreshTheList(selec)}
                        showAllOpen={(selec) => props.showAllOpen(selec)} />

                    <div className={`spaceTop ${(props.showBetweenDts) ? "" : "hideMe"}`}>
                        <div className={"onRight"}>
                            {(props.showBetweenDts) ? <BetweenDates
                                startDTS={props.startDTS} setStartDTS={(dt) => props.setStartDTS(dt)}
                                endDTS={props.endDTS} setEndDTS={(dt) => props.setEndDTS(dt)} /> : ""}
                        </div>
                        <div className={"onRight spaceTopBig"}>
                            <Button className={`btnMediumMnu onRight
                     ${props.selectedBtn == 11 ? "selectedMnuBtn" : ""}`} variant="contained" onClick={() => refreshTheList(11)}>
                                חפש
                            </Button></div>
                    </div>


                </div>
            </Stack>

        </div >
    )
}

export default BuisTollBarMobi;

